import { toCamelCaseKeys } from '@/js/lib/helper/localize-keys';
import jsonData from './genre.json';

interface Genre {
  genreId: number;
  slug: string;
  name: string;
}

export default toCamelCaseKeys(jsonData) as Genre[];
